import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import htmr from "htmr";

dayjs.extend(isToday);
dayjs.extend(isYesterday);

const parseDateTime = (value, { t, format = false }) => {
  if (!value) {
    return "";
  }

  const date = dayjs(new Date(value));

  const time = dayjs(date).format("HH:mm");

  if (date.isYesterday()) {
    return t("yesterday", { time });
  }

  if (date.isToday()) {
    return format ? `${t("today", { time })}` : time;
  }

  return format
    ? dayjs(date).format("DD-MM-YYYY HH:mm")
    : `${dayjs(date).fromNow()} ${time}`;
};

const AuctionStates = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
  CANCELED: "CANCELED",
  EXPIRED: "EXPIRED",
  RESERVED: "RESERVED",
  COMPLETED: "COMPLETED",
  BANNED: "BANNED",
  BID_ONLY: "BID_ONLY",
  COMING_SOON: "COMING_SOON",
};

const ProductStates = {
  DRAFT: "DRAFT",
  CURATION: "CURATION",
  REJECTED: "REJECTED",
  BANNED: "BANNED",
  CANCELED: "CANCELED",
  ACCEPTED: "ACCEPTED",
};

const renderHTML = (markup = "") => {
  return htmr(markup.replace(/\\n/g, "<br>"));
};

export { parseDateTime, renderHTML, AuctionStates, ProductStates };
